import React from "react";
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Dash from './components/Dash';
import FLPrivacyPolicy from './components/FLPrivacyPolicy.js';
import FitnessLogger from './components/FitnessLogger.js';
import FLTermsOfService from './components/FLTermsOfService.js';
import FLDeleteAccount from "./components/FLDeleteAccount.js";
// import Home from './pages/Home';

export default function App() {
    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<Dash />} />

                {/* Re-enable when full portfolio goes live:
                <Route path="/home" element={<Home />} />
                */}
                <Route path="/fitnesslogger" element={<FitnessLogger />} />
                <Route path="/fitnesslogger/terms" element={<FLTermsOfService />} />
                <Route path="/fitnesslogger/policy" element={<FLPrivacyPolicy />} />
                <Route path="/fitnesslogger/delete" element={<FLDeleteAccount />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </div>
    );
}
